import PropTypes from 'prop-types'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { memo, useCallback, useEffect, useState } from 'react'
import ReceiptIcon from '@mui/icons-material/Receipt'
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining'
import FoodBankIcon from '@mui/icons-material/FoodBank'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import { Badge, useMediaQuery } from '@mui/material'
import ShippingPanel from './ShippingPanel'
import CreateOrderPanel from './CreateOrderPanel'
import ProduceOrderPanel from './ProduceOrderPanel'
import axios from 'axios'
import { api } from '../utils/api'
import { getFromStorage } from '../utils/storage'
import SuccessOrderPanel from './SuccessOrderPanel'
import { useDispatch, useSelector } from 'react-redux'
import { currentUserActions, loadingActions } from '../redux/store'
import Loading from './Loading'
import { socket } from '../utils/socket'
import { handleError } from '../utils/error'
import { useNavigate } from 'react-router-dom'
import { borderFormat, mainGreen, mainRed } from '../utils/color'

function TabPanel(props) {
	const { children, value, index, ...other } = props

	return (
		<Box
			role='tabpanel'
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}>
			{value === index && (
				<Box sx={{ p: 3 }}>
					<Typography component={'div'}>{children}</Typography>
				</Box>
			)}
		</Box>
	)
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
}

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	}
}

export default function UserTabs() {
	const { currentUser } = useSelector((state) => state.currentUser)
	const { isLoading } = useSelector((state) => state.isLoading)
	const { tagList } = useSelector((state) => state.filterByTag)
	const dispatch = useDispatch()
	const MemoizedTab = memo(Tab)
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const mediaMd = useMediaQuery('(min-width:768px)')
	const [value, setValue] = useState(0)
	const [ordersQuantity, setOrdersQuantity] = useState()
	const [ordersWeight, setOrdersWeight] = useState()
	const [createOrders, setCreateOrders] = useState()
	const [filterCreateOrders, setFilterCreateOrders] = useState([])
	const [produceOrders, setProduceOrders] = useState()
	const [filterProduceOrders, setFilterProduceOrders] = useState([])
	const [shipOrders, setShipOrders] = useState()
	const [filterShipOrders, setFilterShipOrders] = useState([])

	const [successOrders, setSuccessOrders] = useState()
	const [filterSuccessOrders, setFilterSuccessOrders] = useState([])

	const [handleStartShippingOrders, setHandleStartShippingOrders] = useState()
	const [handleEndShippingOrders, setHandleEndShippingOrders] = useState()

	//------GET CREATE ORDERS------
	const getCreateOrders = useCallback(
		async function () {
			dispatch(loadingActions.isLoading())
			try {
				const response = await axios({
					url: api.GET_CREATE_ORDERS,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				const checkFilter = tagList?.filter((tag) => tag.check)
				if (checkFilter?.length === 0) {
					setCreateOrders(response.data)
					setFilterCreateOrders(response.data)
				} else {
					const filterOrderByTag = []
					response.data?.forEach((order) => {
						order?.tag?.forEach((tag) => {
							tagList.forEach((item) => {
								if (tag.name === item.name && item.check) {
									const findExisted = filterOrderByTag.findIndex((check) => check._id === order._id)
									if (findExisted === -1) {
										filterOrderByTag.push(order)
									}
								}
							})
						})
					})
					setCreateOrders(filterOrderByTag)
				}
				dispatch(loadingActions.isLoaded())
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, navigate, dispatch, tagList],
	)

	useEffect(() => {
		getCreateOrders()
	}, [getCreateOrders])

	const filterTagCreateOrders = useCallback(() => {
		const filterOrderByTag = []
		filterCreateOrders?.forEach((order) => {
			order?.tag?.forEach((tag) => {
				tagList.forEach((item) => {
					if (tag.name === item.name && item.check) {
						const findExisted = filterOrderByTag.findIndex((check) => check._id === order._id)
						if (findExisted === -1) {
							filterOrderByTag.push(order)
						}
					}
				})
			})
		})
		setCreateOrders(filterOrderByTag)
		const checkFilter = tagList?.filter((tag) => tag.check)
		if (checkFilter?.length === 0) {
			setCreateOrders(filterCreateOrders)
		}
	}, [filterCreateOrders, tagList])

	useEffect(() => {
		filterTagCreateOrders()
	}, [tagList, filterTagCreateOrders])

	//------GET PRODUCE ORDERS------
	const getProduceOrders = useCallback(
		async function () {
			dispatch(loadingActions.isLoading())
			try {
				const response = await axios({
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
					url: api.GET_PRODUCE_ORDERS,
					withCredentials: true,
				})
				const checkFilter = tagList?.filter((tag) => tag.check)
				if (checkFilter?.length === 0) {
					setProduceOrders(response.data)
					setFilterProduceOrders(response.data)
				} else {
					const filterOrderByTag = []
					response.data?.forEach((order) => {
						order?.tag?.forEach((tag) => {
							tagList.forEach((item) => {
								if (tag.name === item.name && item.check) {
									const findExisted = filterOrderByTag.findIndex((check) => check._id === order._id)
									if (findExisted === -1) {
										filterOrderByTag.push(order)
									}
								}
							})
						})
					})
					setProduceOrders(filterOrderByTag)
				}
				dispatch(loadingActions.isLoaded())
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token, dispatch, tagList],
	)

	useEffect(() => {
		getProduceOrders()
	}, [getProduceOrders])

	const filterTagProduceOrders = useCallback(() => {
		const filterOrderByTag = []
		filterProduceOrders?.forEach((order) => {
			order?.tag?.forEach((tag) => {
				tagList.forEach((item) => {
					if (tag.name === item.name && item.check) {
						const findExisted = filterOrderByTag.findIndex((check) => check._id === order._id)
						if (findExisted === -1) {
							filterOrderByTag.push(order)
						}
					}
				})
			})
		})
		setProduceOrders(filterOrderByTag)
		const checkFilter = tagList?.filter((tag) => tag.check)
		if (checkFilter?.length === 0) {
			setProduceOrders(filterProduceOrders)
		}
	}, [filterProduceOrders, tagList])

	useEffect(() => {
		filterTagProduceOrders()
	}, [tagList, filterTagProduceOrders])

	//------GET SHIP ORDERS------
	const getShipOrders = useCallback(
		async function () {
			dispatch(loadingActions.isLoading())
			try {
				const response = await axios({
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
					url: api.GET_SHIP_ORDERS,
					withCredentials: true,
				})
				const checkFilter = tagList?.filter((tag) => tag.check)
				if (checkFilter?.length === 0) {
					setShipOrders(response.data)
					setFilterShipOrders(response.data)
				} else {
					const filterOrderByTag = []
					response.data?.forEach((order) => {
						order?.tag?.forEach((tag) => {
							tagList.forEach((item) => {
								if (tag.name === item.name && item.check) {
									const findExisted = filterOrderByTag.findIndex((check) => check._id === order._id)
									if (findExisted === -1) {
										filterOrderByTag.push(order)
									}
								}
							})
						})
					})
					setShipOrders(filterOrderByTag)
				}
				dispatch(loadingActions.isLoaded())
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token, dispatch, tagList],
	)

	useEffect(() => {
		getShipOrders()
	}, [getShipOrders])

	const filterTagShipOrders = useCallback(() => {
		const filterOrderByTag = []
		filterShipOrders?.forEach((order) => {
			order?.tag?.forEach((tag) => {
				tagList.forEach((item) => {
					if (tag.name === item.name && item.check) {
						const findExisted = filterOrderByTag.findIndex((check) => check._id === order._id)
						if (findExisted === -1) {
							filterOrderByTag.push(order)
						}
					}
				})
			})
		})
		setShipOrders(filterOrderByTag)
		const checkFilter = tagList?.filter((tag) => tag.check)
		if (checkFilter?.length === 0) {
			setShipOrders(filterShipOrders)
		}
	}, [filterShipOrders, tagList])

	useEffect(() => {
		filterTagShipOrders()
	}, [tagList, filterTagShipOrders])

	//------GET SUCCESS ORDERS------
	const getSuccessOrders = useCallback(
		async function () {
			dispatch(loadingActions.isLoading())
			try {
				const response = await axios({
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
					url: api.GET_SUCCESS_ORDERS,
					withCredentials: true,
				})
				const checkFilter = tagList?.filter((tag) => tag.check)
				if (checkFilter?.length === 0) {
					setSuccessOrders(response.data)
					setFilterSuccessOrders(response.data)
				} else {
					const filterOrderByTag = []
					response.data?.forEach((order) => {
						order?.tag?.forEach((tag) => {
							tagList.forEach((item) => {
								if (tag.name === item.name && item.check) {
									const findExisted = filterOrderByTag.findIndex((check) => check._id === order._id)
									if (findExisted === -1) {
										filterOrderByTag.push(order)
									}
								}
							})
						})
					})
					setSuccessOrders(filterOrderByTag)
				}
				dispatch(loadingActions.isLoaded())
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token, dispatch, tagList],
	)

	useEffect(() => {
		getSuccessOrders()
	}, [getSuccessOrders])

	const filterTagSuccessOrders = useCallback(() => {
		const filterOrderByTag = []
		filterSuccessOrders?.forEach((order) => {
			order?.tag?.forEach((tag) => {
				tagList.forEach((item) => {
					if (tag.name === item.name && item.check) {
						const findExisted = filterOrderByTag.findIndex((check) => check._id === order._id)
						if (findExisted === -1) {
							filterOrderByTag.push(order)
						}
					}
				})
			})
		})
		setSuccessOrders(filterOrderByTag)
		const checkFilter = tagList?.filter((tag) => tag.check)
		if (checkFilter?.length === 0) {
			setSuccessOrders(filterSuccessOrders)
		}
	}, [filterSuccessOrders, tagList])

	useEffect(() => {
		filterTagSuccessOrders()
	}, [tagList, filterTagSuccessOrders])

	const getOrdersQuantity = useCallback(
		async function () {
			dispatch(loadingActions.isLoading())
			try {
				const response = await axios({
					url: api.GET_ORDERS_QUANTITY,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setOrdersQuantity(response.data)
				dispatch(loadingActions.isLoaded())
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token, dispatch],
	)

	useEffect(() => {
		getOrdersQuantity()
	}, [getOrdersQuantity])

	const getOrdersWeight = useCallback(
		async function () {
			dispatch(loadingActions.isLoading())
			try {
				const response = await axios({
					url: api.GET_ORDERS_WEIGHT,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setOrdersWeight(response.data)
				dispatch(loadingActions.isLoaded())
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token, dispatch],
	)

	useEffect(() => {
		getOrdersWeight()
	}, [getOrdersWeight])

	const getStartShippingServiceOrders = useCallback(
		async function () {
			try {
				const response = await axios({
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
					url: api.GET_START_SHIPPING_SERVICE_ORDERS,
					withCredentials: true,
				})
				setHandleStartShippingOrders(response.data)

				dispatch(loadingActions.isLoaded())
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token, dispatch],
	)

	useEffect(() => {
		getStartShippingServiceOrders()
	}, [getStartShippingServiceOrders])

	const getEndShippingServiceOrders = useCallback(
		async function () {
			try {
				const response = await axios({
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
					url: api.GET_END_SHIPPING_SERVICE_ORDERS,
					withCredentials: true,
				})
				setHandleEndShippingOrders(response.data)

				dispatch(loadingActions.isLoaded())
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token, dispatch],
	)

	useEffect(() => {
		getEndShippingServiceOrders()
	}, [getEndShippingServiceOrders])

	useEffect(() => {
		const listener = (data) => {
			setOrdersQuantity((prev) => {
				const updateCreateOrdersQuantity = { ...prev }
				updateCreateOrdersQuantity.createOrdersQuantity = data
				return updateCreateOrdersQuantity
			})
		}
		socket.on(`create-order-quantity-${currentUser.store}`, listener)
		return () => {
			socket.off(`create-order-quantity-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setOrdersQuantity((prev) => {
				const updateProduceOrdersQuantity = { ...prev }
				updateProduceOrdersQuantity.produceOrdersQuantity = data
				return updateProduceOrdersQuantity
			})
		}
		socket.on(`produce-order-quantity-${currentUser.store}`, listener)
		return () => {
			socket.off(`produce-order-quantity-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setOrdersQuantity((prev) => {
				const updateShipOrdersQuantity = { ...prev }
				updateShipOrdersQuantity.shipOrdersQuantity = data
				return updateShipOrdersQuantity
			})
		}
		socket.on(`ship-order-quantity-${currentUser.store}`, listener)
		return () => {
			socket.off(`ship-order-quantity-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setOrdersQuantity((prev) => {
				const updateSuccessOrdersQuantity = { ...prev }
				updateSuccessOrdersQuantity.successOrdersQuantity = data
				return updateSuccessOrdersQuantity
			})
		}
		socket.on(`success-order-quantity-${currentUser.store}`, listener)
		return () => {
			socket.off(`success-order-quantity-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setOrdersWeight((prev) => {
				const updateCreateOrdersWeight = { ...prev }
				updateCreateOrdersWeight.createOrdersWeight = data
				return updateCreateOrdersWeight
			})
		}
		socket.on(`create-order-weight-${currentUser.store}`, listener)
		return () => {
			socket.off(`create-order-weight-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setOrdersWeight((prev) => {
				const updateProduceOrdersWeight = { ...prev }
				updateProduceOrdersWeight.produceOrdersWeight = data
				return updateProduceOrdersWeight
			})
		}
		socket.on(`produce-order-weight-${currentUser.store}`, listener)
		return () => {
			socket.off(`produce-order-weight-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setOrdersWeight((prev) => {
				const updateShipOrdersWeight = { ...prev }
				updateShipOrdersWeight.shipOrdersWeight = data
				return updateShipOrdersWeight
			})
		}
		socket.on(`ship-order-weight-${currentUser.store}`, listener)
		return () => {
			socket.off(`ship-order-weight-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setOrdersWeight((prev) => {
				const updateTodaySuccessOrdersWeight = { ...prev }
				updateTodaySuccessOrdersWeight.todaySuccessOrdersWeight = data
				return updateTodaySuccessOrdersWeight
			})
		}
		socket.on(`success-order-weight-${currentUser.store}`, listener)
		return () => {
			socket.off(`success-order-weight-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = () => {
			alert('Trùng giờ với 1 đơn khác, vui lòng đặt lại đơn hẹn giờ')
		}
		socket.on(`reject-timer-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`reject-timer-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	const handleChange = useCallback((event, newValue) => {
		setValue(newValue)
	}, [])

	//------SOCKET POST CREATE ORDER AND GET START PRODUCE ORDER------
	useEffect(() => {
		const listener = (data) => {
			console.log(`get-create-order-${currentUser.store}`, data)
			if (data?._id) {
				setCreateOrders((prev) => {
					const updateCreateOrders = [...prev]
					updateCreateOrders.push(data)
					return updateCreateOrders
				})
			}
		}
		socket.on(`get-create-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-create-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setCreateOrders((prev) => {
				const index = prev?.findIndex((order) => order._id === data?._id)
				if (index !== -1) {
					const updateCreateOrders = [...prev]
					updateCreateOrders[index] = data
					return updateCreateOrders
				}
				return prev
			})
		}

		console.log(`get-pending-produce-order-${currentUser.store}`, currentUser.store)
		socket.on(`get-pending-produce-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-pending-produce-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setCreateOrders((createOrders) => createOrders?.filter((order) => order._id !== data?._id))
		}
		socket.on('get-delete-create-order', listener)
		return () => {
			socket.off('get-delete-create-order', listener)
		}
	}, [])

	// CHUYỂN CỬA HÀNG
	useEffect(() => {
		const listener = (data) => {
			setCreateOrders((createOrders) => createOrders?.filter((order) => order._id !== data?._id))
		}
		socket.on(`remove-transfer-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`remove-transfer-order-${currentUser.store}`, listener)
		}
	})

	useEffect(() => {
		const listener = (data) => {
			setCreateOrders((prev) => {
				const index = prev?.findIndex((order) => order._id === data?._id)
				if (index === -1) {
					const updateCreateOrders = [...prev]
					updateCreateOrders.push(data)
					return updateCreateOrders
				}
				return prev
			})
		}
		socket.on(`get-transfer-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-transfer-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setCreateOrders((prev) => prev?.filter((order) => order._id !== data?._id))
		}
		socket.on(`get-end-create-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-end-create-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setCreateOrders((prev) => {
				const index = prev?.findIndex((order) => order._id === data?._id)
				if (index !== -1) {
					const updateCreateOrders = [...prev]
					updateCreateOrders[index] = data
					return updateCreateOrders
				}
				return prev
			})
		}
		socket.on(`add-tag-${currentUser.store}`, listener)
		return () => {
			socket.off(`add-tag-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setCreateOrders((prev) => {
				const index = prev?.findIndex((order) => order._id === data?._id)
				if (index !== -1) {
					const updateCreateOrders = [...prev]
					updateCreateOrders[index] = data
					return updateCreateOrders
				}
				return prev
			})
		}
		socket.on(`get-update-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-update-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	//------SOCKET GET PRODUCE ORDER------
	useEffect(() => {
		const listener = (data) => {
			setProduceOrders(data)
		}
		socket.on(`get-start-produce-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-start-produce-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setProduceOrders((prev) => {
				const index = prev?.findIndex((order) => order._id === data?._id)
				if (index !== -1) {
					const updateProduceOrders = [...prev]
					updateProduceOrders[index] = data
					return updateProduceOrders
				}
				return prev
			})
		}
		socket.on(`get-end-produce-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-end-produce-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setProduceOrders((prev) => prev?.filter((order) => order._id !== data?._id))
		}
		socket.on(`get-start-ship-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-start-ship-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setProduceOrders((prev) => prev?.filter((order) => order._id !== data))
		}
		socket.on(`handle-shipping-service-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`handle-shipping-service-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			const index = produceOrders?.findIndex((order) => order._id === data?._id)
			if (index === -1) {
				const updateProduceOrders = [...produceOrders]
				updateProduceOrders.push(data)
				setProduceOrders(updateProduceOrders)
			}
		}
		socket.on(`undo-shipping-service-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`undo-shipping-service-order-${currentUser.store}`, listener)
		}
	})

	useEffect(() => {
		const listener = (data) => {
			setProduceOrders((prev) => {
				const index = prev?.findIndex((order) => order._id === data?._id)
				if (index !== -1) {
					const updateProduceOrders = [...prev]
					updateProduceOrders[index] = data
					return updateProduceOrders
				}
				return prev
			})
		}
		socket.on(`add-tag-${currentUser.store}`, listener)
		return () => {
			socket.off(`add-tag-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setHandleStartShippingOrders((prev) => {
				const index = prev[data.serviceIndex]?.order.findIndex((order) => order._id === data.order._id)

				const orderUpdate = prev[data.serviceIndex]?.order
				orderUpdate[index] = data.order
				const updateObject = {
					...prev[data.serviceIndex],
					order: orderUpdate,
				}

				const updateHandleStartShippingOrders = [...prev]
				updateHandleStartShippingOrders[data.serviceIndex] = updateObject
				return updateHandleStartShippingOrders
			})
		}
		socket.on(`add-tag-start-shipping-service-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`add-tag-start-shipping-service-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setProduceOrders((prev) => {
				const index = prev?.findIndex((order) => order._id === data?._id)
				if (index !== -1) {
					const updateProduceOrders = [...prev]
					updateProduceOrders[index] = data
					return updateProduceOrders
				}
				return prev
			})
		}
		socket.on(`get-update-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-update-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setHandleStartShippingOrders((prev) => {
				const index = prev[data.serviceIndex]?.order.findIndex((order) => order._id === data.order._id)

				const orderUpdate = prev[data.serviceIndex]?.order
				orderUpdate[index] = data.order
				const updateObject = {
					...prev[data.serviceIndex],
					order: orderUpdate,
				}

				const updateHandleStartShippingOrders = [...prev]
				updateHandleStartShippingOrders[data.serviceIndex] = updateObject
				return updateHandleStartShippingOrders
			})
		}
		socket.on(`get-update-start-shipping-service-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-update-start-shipping-service-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setProduceOrders((produceOrders) => produceOrders?.filter((order) => order._id !== data?._id))
		}
		socket.on('get-delete-produce-order', listener)
		return () => {
			socket.off('get-delete-produce-order', listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setProduceOrders((prev) => {
				const index = prev?.findIndex((order) => order._id === data?._id)
				if (index !== -1) {
					const updateProduceOrders = [...prev]
					updateProduceOrders[index] = data
					return updateProduceOrders
				}
				return prev
			})
		}
		socket.on(`get-pending-produce-delete-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-pending-produce-delete-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setHandleStartShippingOrders((prev) => {
				const index = prev[data.serviceIndex]?.order.findIndex((order) => order._id === data.order._id)

				const orderUpdate = prev[data.serviceIndex]?.order
				orderUpdate[index] = data.order
				const updateObject = {
					...prev[data.serviceIndex],
					order: orderUpdate,
				}

				const updateHandleStartShippingOrders = [...prev]
				updateHandleStartShippingOrders[data.serviceIndex] = updateObject
				return updateHandleStartShippingOrders
			})
		}
		socket.on(`get-end-produce-shipping-service-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-end-produce-shipping-service-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setHandleStartShippingOrders(data)
		}
		socket.on(`get-start-shipping-service-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-start-shipping-service-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	//------SOCKET GET END SHIPPING SERVICE ORDER------
	useEffect(() => {
		const listener = (data) => {
			setHandleEndShippingOrders(data)
		}
		socket.on(`get-end-shipping-service-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-end-shipping-service-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	//------SOCKET GET SHIP ORDER------
	useEffect(() => {
		const listener = (data) => {
			setShipOrders(data)
		}
		socket.on(`get-new-start-ship-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-new-start-ship-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setShipOrders((shipOrders) => shipOrders?.filter((order) => order._id !== data?._id))
		}
		socket.on(`get-end-ship-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-end-ship-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setShipOrders((prev) => {
				const index = prev?.findIndex((order) => order._id === data?._id)
				if (index !== -1) {
					const updateShipOrders = [...prev]
					updateShipOrders[index] = data
					return updateShipOrders
				}
				return prev
			})
		}
		socket.on(`add-tag-${currentUser.store}`, listener)
		return () => {
			socket.off(`add-tag-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setShipOrders((prev) => {
				const index = prev?.findIndex((order) => order._id === data?._id)
				if (index !== -1) {
					const updateShipOrders = [...prev]
					updateShipOrders[index] = data
					return updateShipOrders
				}
				return prev
			})
		}
		socket.on(`get-update-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-update-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setShipOrders((shipOrders) => shipOrders?.filter((order) => order._id !== data?._id))
		}
		socket.on('get-delete-ship-order', listener)
		return () => {
			socket.off('get-delete-ship-order', listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setShipOrders((prev) => {
				const index = prev?.findIndex((order) => order._id === data?._id)
				if (index !== -1) {
					const updateShipOrders = [...prev]
					updateShipOrders[index] = data
					return updateShipOrders
				}
				return prev
			})
		}
		socket.on(`get-pending-produce-delete-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-pending-produce-delete-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setHandleEndShippingOrders((prev) => {
				const index = prev[data.serviceIndex]?.order.findIndex((order) => order._id === data.order._id)

				const orderUpdate = prev[data.serviceIndex]?.order
				orderUpdate[index] = data.order
				const updateObject = {
					...prev[data.serviceIndex],
					order: orderUpdate,
				}

				const updateHandleEndShippingOrders = [...prev]
				updateHandleEndShippingOrders[data.serviceIndex] = updateObject

				return updateHandleEndShippingOrders
			})
		}
		socket.on(`add-tag-end-shipping-service-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`add-tag-end-shipping-service-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setHandleEndShippingOrders((prev) => {
				const index = prev[data.serviceIndex]?.order.findIndex((order) => order._id === data.order._id)

				const orderUpdate = prev[data.serviceIndex]?.order
				orderUpdate[index] = data.order
				const updateObject = {
					...prev[data.serviceIndex],
					order: orderUpdate,
				}

				const updateHandleEndShippingOrders = [...prev]
				updateHandleEndShippingOrders[data.serviceIndex] = updateObject

				return updateHandleEndShippingOrders
			})
		}
		socket.on(`get-update-start-shipping-service-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-update-start-shipping-service-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	//------SOCKET GET SUCCESS ORDER------
	useEffect(() => {
		const listener = (data) => {
			setSuccessOrders(data)
		}
		socket.on(`get-success-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-success-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setSuccessOrders((prev) => {
				const index = prev?.findIndex((order) => order._id === data.newQuickPurchaseOrder._id)
				if (index === -1) {
					const updateSuccessOrders = [...prev]
					updateSuccessOrders.push(data.newQuickPurchaseOrder)
					return updateSuccessOrders
				}
				return prev
			})
		}
		socket.on(`get-success-quick-order-${currentUser.store}`, listener)

		return () => {
			socket.off(`get-success-quick-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setSuccessOrders((prev) => {
				const index = prev?.findIndex((order) => order._id === data?._id)
				if (index !== -1) {
					const updateSuccessOrders = [...prev]
					updateSuccessOrders[index] = data
					return updateSuccessOrders
				}
				return prev
			})
		}
		socket.on(`get-update-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-update-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	useEffect(() => {
		const listener = (data) => {
			setSuccessOrders((prev) => {
				const index = prev?.findIndex((order) => order._id === data?._id)
				if (index !== -1) {
					const updateSuccessOrders = [...prev]
					updateSuccessOrders[index] = data
					return updateSuccessOrders
				}
				return prev
			})
		}
		socket.on(`get-pending-produce-delete-order-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-pending-produce-delete-order-${currentUser.store}`, listener)
		}
	}, [currentUser.store])

	return (
		<Box>
			<Box sx={{ borderBottom: 1, borderColor: 'divider', color: '#000' }}>
				<Tabs
					value={value}
					onChange={handleChange}
					sx={{
						position: 'fixed',
						zIndex: '999',
						background: '#fff',
						top: mediaMd ? '64px' : '56px',
						left: mediaMd ? 300 : 0,
						right: 0,
						borderBottom: borderFormat,
					}}
					TabIndicatorProps={{ style: { background: mainGreen } }}>
					<MemoizedTab
						icon={
							<Badge
								badgeContent={value === 0 ? ordersQuantity?.createOrdersQuantity : 0}
								sx={{
									'& .MuiBadge-badge': {
										color: '#fff',
										backgroundColor: mainRed,
									},
								}}>
								<ReceiptIcon sx={value === 0 ? { color: '#088848' } : {}} />
							</Badge>
						}
						iconPosition='start'
						sx={{
							'& .MuiTab-root': {
								textTransform: 'none',
							},
						}}
						label={
							value === 0 ? (
								<span
									style={{
										paddingLeft: '2px',
										paddingTop: '8px',
										color: '#088848',
									}}>
									{ordersWeight?.createOrdersWeight}kg
								</span>
							) : (
								''
							)
						}
						{...a11yProps(0)}
					/>
					<MemoizedTab
						icon={
							<Badge
								badgeContent={value === 1 ? ordersQuantity?.produceOrdersQuantity : 0}
								sx={{
									'& .MuiBadge-badge': {
										color: '#fff',
										backgroundColor: mainGreen,
									},
								}}>
								<FoodBankIcon
									sx={
										value === 1
											? {
													color: mainRed,
												}
											: {}
									}
								/>
							</Badge>
						}
						iconPosition='start'
						label={
							value === 1 ? (
								<span
									style={{
										paddingLeft: '2px',
										paddingTop: '8px',
										color: mainRed,
									}}>
									{ordersWeight?.produceOrdersWeight}kg
								</span>
							) : (
								''
							)
						}
						{...a11yProps(1)}
					/>
					<MemoizedTab
						icon={
							<Badge
								badgeContent={value === 2 ? ordersQuantity?.shipOrdersQuantity : 0}
								sx={{
									'& .MuiBadge-badge': {
										color: '#fff',
										backgroundColor: mainGreen,
									},
								}}>
								<DeliveryDiningIcon sx={value === 2 ? { color: mainRed } : {}} />
							</Badge>
						}
						iconPosition='start'
						label={
							value === 2 ? (
								<span
									style={{
										paddingLeft: '2px',
										paddingTop: '8px',
										color: mainRed,
									}}>
									{ordersWeight?.shipOrdersWeight}kg
								</span>
							) : (
								''
							)
						}
						{...a11yProps(2)}
					/>
					<MemoizedTab
						icon={
							<Badge
								badgeContent={value === 3 ? ordersQuantity?.successOrdersQuantity : 0}
								sx={{
									'& .MuiBadge-badge': {
										color: '#fff',
										backgroundColor: mainRed,
									},
								}}>
								<ThumbUpIcon sx={value === 3 ? { color: '#088848' } : {}} />
							</Badge>
						}
						iconPosition='start'
						label={
							value === 3 ? (
								<span
									style={{
										paddingLeft: '2px',
										paddingTop: '8px',
										color: '#088848',
									}}>
									{ordersWeight?.todaySuccessOrdersWeight}kg
								</span>
							) : (
								''
							)
						}
						{...a11yProps(2)}
					/>
				</Tabs>
			</Box>
			{isLoading ? (
				<Loading />
			) : (
				<>
					<TabPanel value={value} index={0}>
						<CreateOrderPanel createOrdersProps={createOrders} />
					</TabPanel>
					<TabPanel value={value} index={1}>
						<ProduceOrderPanel
							produceOrdersProps={produceOrders}
							handleStartShippingOrdersProps={handleStartShippingOrders}
						/>
					</TabPanel>
					<TabPanel value={value} index={2}>
						<ShippingPanel shipOrdersProps={shipOrders} handleEndShippingOrdersProps={handleEndShippingOrders} />
					</TabPanel>
					<TabPanel value={value} index={3}>
						<SuccessOrderPanel successOrdersProps={successOrders} />
					</TabPanel>
				</>
			)}

			<div style={{ height: '100px' }}></div>
		</Box>
	)
}
